import { ILocation } from "@sp-crm/core";
import { MapMarkerId } from "components/community-search/community-map/types";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";
import * as React from "react";
import Map, { NavigationControl, ScaleControl } from "react-map-gl/maplibre";
import { NextgenMapMarker } from "../community-search/community-map/nextgen-marker";
import { MapErrorBoundary } from "./map-error-boundary";
import { MarkerIconColor } from "./types";
import { useMapStyle } from "./use-map-style";

interface NextgenEntityMapProps {
    entityId: MapMarkerId;
    location: ILocation | null;
    iconType: MarkerIconColor;
    zoom: number;
}

export const NextgenEntityMap: React.FC<NextgenEntityMapProps> = props => {
    const { location, entityId, iconType, zoom } = props;
    const mapStyle = useMapStyle();

    if (!location) {
        return <span />;
    }

    return (
        <MapErrorBoundary>
            <div style={{ position: "relative", height: 200 }}>
                <Map
                    mapLib={maplibregl}
                    attributionControl={false}
                    initialViewState={{
                        longitude: location.loc[0],
                        latitude: location.loc[1],
                        zoom,
                    }}
                    style={{ height: 200 }}
                    mapStyle={mapStyle}>
                    <NavigationControl position="top-left" />
                    <ScaleControl />
                    <NextgenMapMarker
                        id={entityId}
                        isHovered={false}
                        iconType={iconType}
                        location={location}
                    />
                </Map>
            </div>
        </MapErrorBoundary>
    );
};
